import React from 'react';
import styled from 'styled-components';
import { ButtonText, Checkbox } from 'components';
import { theme, toRem } from 'design';
import { Text } from '../Typography';

const CheckboxRow = styled.div`
  display: flex;
  flex-flow: row wrap;
  margin-top: ${toRem(8)};
  align-items: center;

  label {
    margin-right: ${toRem(8)};
  }

  input {
    margin-right: ${toRem(4)};
  }
`;

const SelectAllButton = styled(ButtonText)`
  white-space: nowrap;
  font-size: ${toRem(12)};
  margin-left: ${toRem(8)};
  color: ${theme.color.primary[500]};

  @media (min-width: ${theme.breakpoint.large}px) {
    display: block;
  }
`;

const StyledCheckbox = styled(Checkbox)`
  width: auto;
  height: ${toRem(40)};
  margin-left: ${toRem(8)};
  text-transform: capitalize;

  @media (min-width: ${theme.breakpoint.large}px) {
    height: auto;
  }
`;

const PaymentStatusLabel = styled(Text).attrs({
  as: 'label',
})`
  font-size: ${toRem(11)};
  font-weight: ${theme.font.weight.medium};
  display: none;

  @media (min-width: ${theme.breakpoint.large}px) {
    font-size: ${toRem(13.25)};
    color: ${theme.color.neutral[500]};
    white-space: nowrap;
    display: block;
  }
`;

interface IStatusCheckboxProps {
  label: string;
  statuses: string[];
  activeStatus: string[];
  selectAll?: boolean;
  onChange(selectedStatus: string[]): void;
}

export const StatusCheckbox = ({ label, statuses, activeStatus, selectAll = true, onChange }: IStatusCheckboxProps) => {
  const onToggleCheckbox = (value: string, checked: boolean) => {
    let status;
    if (checked === true) {
      status = [...activeStatus, value];
    } else {
      status = activeStatus.filter((val) => val !== value);
    }
    onChange(status);
  };

  const onSelectAll = () => {
    onChange(statuses);
  };

  const onDeselectAll = () => {
    onChange([]);
  };

  return (
    <CheckboxRow>
      <PaymentStatusLabel>{label}</PaymentStatusLabel>
      {statuses.map((value) => (
        <StyledCheckbox
          id={`status-checkbox-${value}`}
          name={`status-checkbox-${value}`}
          key={`status-checkbox-${value}`}
          data-cy={`status-checkbox-${value}`}
          label={value}
          size="small"
          checked={activeStatus.includes(value)}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            onToggleCheckbox(value, e.target.checked);
          }}
        />
      ))}
      {selectAll &&
        (activeStatus.length === statuses.length ? (
          <SelectAllButton
            label="Deselect All"
            onClick={() => {
              onDeselectAll();
            }}
          />
        ) : (
          <SelectAllButton
            label="Select All"
            onClick={() => {
              onSelectAll();
            }}
          />
        ))}
    </CheckboxRow>
  );
};
